// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Quicksand', 'Quicksand Fallback'","fontStyle":"normal"},"className":"__className_4fe76a"};